import React, { useState } from "react";
import { CustomButton } from "../../../../components/Button/Button";
import DownArrow from "../../../../styles/svg/downArrow.svg";
import { Chip, Stack } from "@mui/material";
import CustomMenu from "../../../../components/Menu";

function PieChartBoardList({ data, totalHours }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  console.log("pie chart data === ", data);
  return (
    <Stack alignItems={"end"}>
      <CustomButton
        variant="outlined"
        color="primary"
        id="epics-board-dropdown"
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        endIcon={<img src={DownArrow} alt="downArrow" />}
        className="pie-chart-board-list">
        <Chip
          label={
            <div className="d-flex justify-content-space-between">
              <p className="filter-name">All Boards</p>
            </div>
          }
          className="filter-chip"
        />
      </CustomButton>

      <CustomMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        isApplyCustomMenuCss={false}
        className="custom-menu-box-shadow-none">
        <div className="pie-chart-board-list-menu-cont">
          <div className="all-boards-text">{`All Boards (${totalHours})`}</div>
          {data.map((item, index) => (
            <div key={index} className="pie-chart-board-list-menu-item">
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  marginRight: "8px",
                }}
              />
              <span className="pie-chart-board-list-menu-item-text">
                {item.name}
              </span>
              <span className="pie-chart-board-list-menu-item-value">
                {` (${item.value})`}
              </span>
            </div>
          ))}
        </div>
      </CustomMenu>
    </Stack>
  );
}

export default PieChartBoardList;
